var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "browse-inline-iframe", style: _vm.panelStyle },
    [
      _c("div", {
        staticClass: "browse-inline-iframe-resize-handle",
        class: { "is-left": _vm.isLeft },
        on: { mousedown: _vm.onResizeStart },
      }),
      _c(
        "div",
        { staticClass: "browse-inline-iframe-header" },
        [
          _c("span", { staticClass: "browse-inline-iframe-title" }, [
            _vm._v(_vm._s(_vm.title)),
          ]),
          _c("w-spacer"),
          _c(
            "w-link",
            { on: { click: _vm.close } },
            [_c("w-fa", { attrs: { icon: "times" } })],
            1
          ),
        ],
        1
      ),
      _c("iframe", {
        ref: "frame",
        staticClass: "browse-inline-iframe-frame",
        class: { "no-pointer-events": _vm.resizing },
        attrs: {
          src: _vm.state.inlineIframeUrl || undefined,
          frameborder: "0",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }